export async function globalLogout() {
    const apiBase = localStorage.getItem("api").replace(/^\//, "").replace(/\/$/, "");
    try {
        await axios.post(`${apiBase()}/admin/profile/logout`);
    } catch (err) {
        console.warn("Logout call failed:", err);
    } finally {
        // Local cleanup
        localStorage.removeItem("user");
        localStorage.removeItem("expirationTime");
        localStorage.removeItem("lastHttp");
        localStorage.removeItem("openGroups");

        // Redirect
        window.location.href = "/login";
    }
}
